import Logo from "../assets/logo.png"

const PageLoader = () => {
  return (
    <div className="w-full h-[100vh] flex items-center justify-center">
      <img src={Logo} className="w-[300px] animate-pulse" />
    </div>
  );
};

export default PageLoader;
